import { render, staticRenderFns } from "./AllReceivers.vue?vue&type=template&id=20eebe77&"
import script from "./AllReceivers.vue?vue&type=script&lang=js&"
export * from "./AllReceivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports